import type { PersistenceLevel } from '@/core/flux.service';
import { Store } from '@/core/flux.service';
import type { ActionBoard } from './actionBoard.types';

export class ActionBoardStore extends Store {
  persistenceLevel: PersistenceLevel = 'WORKSHEET';
  static readonly storeName = 'sqActionBoardStore';

  initialize() {
    this.state = this.immutable({
      boardId: undefined,
      board: undefined,
      tileRefreshRequest: undefined,
    });
  }

  get tileRefreshRequest(): { tileId?: string; token: number } | undefined {
    return this.state.get('tileRefreshRequest');
  }

  get boardId(): string | undefined {
    return this.state.get('boardId');
  }

  get board(): ActionBoard | undefined {
    return this.state.get('board');
  }

  dehydrate(): { boardId?: string } {
    return {
      boardId: this.state.get('boardId'),
    };
  }

  rehydrate(dehydratedState: { boardId?: string }) {
    if (dehydratedState.boardId) {
      this.state.set('boardId', dehydratedState.boardId);
    }
  }
  protected readonly handlers = {
    ACTION_BOARD_SET_BOARD_ID: (payload: { boardId: string }) => {
      this.state.set('boardId', payload.boardId);
      console.log('set boardId', payload.boardId);
    },

    ACTION_BOARD_SET_BOARD: (payload: { board: ActionBoard }) => {
      this.state.set('board', payload.board);
      this.state.set('boardId', payload.board.id);
    },

    ACTION_BOARD_REFRESH_TILE: (payload: { tileId?: string; token: number }) => {
      this.state.set('tileRefreshRequest', payload);
    },

    ACTION_BOARD_CLEAR_TILE_REFRESH: (payload: { token: number }) => {
      const currentRequest = this.state.get('tileRefreshRequest');
      if (currentRequest?.token !== payload.token) {
        return;
      }
      this.state.set('tileRefreshRequest', undefined);
    },
  };
}
